import { Icon, SubsectionGroup } from '@sleepstation/components'
import { CopyBulletList } from '@sleepstation/components-copy'
import { SIZE } from '@sleepstation/const'
import {
  backgroundColor,
  color,
  padding,
  right,
  themeColor,
  top,
} from '@sleepstation/style-api-helpers'
import { outset } from '@sleepstation/style-mixins'
import { reversedTheme } from '@sleepstation/themes-public-site'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import { identity } from 'ramda'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  ${outset()}
  ${padding([
    [0.75, 0.5],
    [0.75, 0.5],
    [1, 1, 1.25],
  ])}
  ${backgroundColor(`background`)}
  position: relative;
`

const IconWrapper = styled.div`
  position: absolute;
  ${right(-0.5)}
  ${top(-0.5)}
  border-radius: 50%;
`

const Circle = styled.div`
  ${padding(0.33)}
  ${backgroundColor(`background`)}
  ${color(`body`)}
  border-radius: 50%;
  border: 1px solid ${themeColor(`border`)};
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const ListCard = ({ title, iconName, items }) => (
  <Layout>
    <SubsectionGroup title={title}>
      <CopyBulletList>{renderList(identity, items)}</CopyBulletList>
    </SubsectionGroup>
    <IconWrapper>
      <ThemeProvider theme={reversedTheme}>
        <Circle>
          <Icon name={iconName} size={SIZE.LARGE} />
        </Circle>
      </ThemeProvider>
    </IconWrapper>
  </Layout>
)

ListCard.propTypes = {
  title: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
}

ListCard.defaultProps = {}

export default ListCard
